await import(`@liferay/language/${Liferay.ThemeDisplay.getLanguageId()}/data-engine-js-components-web/all.js`);
/**
 * SPDX-FileCopyrightText: (c) 2000 Liferay, Inc. https://liferay.com
 * SPDX-License-Identifier: LGPL-2.1-or-later OR LicenseRef-Liferay-DXP-EULA-2.0.0-2023-06
 */

export {default as formBuilderReducer} from './formBuilderReducer.es';
export {default as objectFieldsReducer} from './objectFieldsReducer.es';
export {default as objectRelationshipReducer} from './objectRelationshipReducer';
export {default as pageReducer} from './pageReducer.es';
export {default as paginationReducer} from './paginationReducer.es';
export {default as repeatableDNDReducer} from './repeatableDNDReducer.es';
export {default as rulesReducer} from './rulesReducer.es';
